import { get, post } from "../lib";

const { REACT_APP_API_URL } = process.env;

export const deviceApi = {
	allDevices: (token: string | null) => get(`${REACT_APP_API_URL}/device/list/all`, undefined, token || ''),
	getRealTimeData: (devId: string, token: string | null) => get(`${REACT_APP_API_URL}/device/${devId}/tags`, undefined, token || ''),
	getDevice: (devId: string, token: string | null) => get(`${REACT_APP_API_URL}/device/${devId}`, undefined, token || ''),
	updateDeviceSchedule: (devId: string, req: any, token: string | null) => post(`${REACT_APP_API_URL}/device/${devId}/schedule`, req, token || '')
};